import { render, staticRenderFns } from "./TsNftWidgetChest.vue?vue&type=template&id=72931b1e&scoped=true&"
import script from "./TsNftWidgetChest.vue?vue&type=script&lang=js&"
export * from "./TsNftWidgetChest.vue?vue&type=script&lang=js&"
import style0 from "./TsNftWidgetChest.vue?vue&type=style&index=0&id=72931b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72931b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VContainer,VIcon,VImg,VRow,VScaleTransition,VSheet,VSkeletonLoader,VSlideGroup,VSlideItem,VSubheader})
